/*
 * Popup "Livraison France uniquement" pour les visiteurs en Suisse.
 * Markup : <template id="mdl-ch-popup-template"> (snippets/mdl_ch_delivery_popup.liquid).
 *
 * Détection, par ordre :
 *   1. fuseau horaire du navigateur Europe/Zurich, ou langue de région suisse (fr-CH, de-CH, ...) : instantané, local ;
 *   2. sinon, géolocalisation IP (Cloudflare trace, puis api.country.is en secours), appelée une fois la page
 *      chargée, avec timeout 2,5 s, résultat mis en cache 7 jours (localStorage `mdl_ch_popup_geo`).
 *      L'IP du visiteur est donc transmise à ce service tiers : à mentionner dans la politique de confidentialité.
 *   En cas d'échec de l'appel, rien n'est affiché.
 * Mémorisation de la fermeture : localStorage `mdl_ch_popup_dismissed` (timestamp), durée DISMISS_DAYS.
 * QA : ajouter ?ch_popup=1 à l'URL force l'affichage (ignore la mémorisation).
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'mdl_ch_popup_dismissed';
  var DISMISS_DAYS = 30;
  var TEMPLATE_ID = 'mdl-ch-popup-template';
  var GEO_CACHE_KEY = 'mdl_ch_popup_geo';
  var GEO_CACHE_DAYS = 7;
  var GEO_TIMEOUT_MS = 2500;

  if (window.__mdlChPopupInit) return;
  window.__mdlChPopupInit = true;

  function readStorage() {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function writeStorage() {
    try {
      window.localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (e) {
      /* stockage indisponible : la popup réapparaîtra à la prochaine page */
    }
  }

  function isDismissed() {
    var raw = readStorage();
    if (!raw) return false;
    var ts = parseInt(raw, 10);
    if (!ts) return false;
    return Date.now() - ts < DISMISS_DAYS * 24 * 60 * 60 * 1000;
  }

  function isForced() {
    try {
      return new URLSearchParams(window.location.search).get('ch_popup') === '1';
    } catch (e) {
      return false;
    }
  }

  function isSwissVisitor() {
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (tz === 'Europe/Zurich') return true;
    } catch (e) {
      /* ignore */
    }
    var langs = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
    for (var i = 0; i < langs.length; i++) {
      if (/^[a-z]{2,3}-CH$/i.test(langs[i] || '')) return true;
    }
    return false;
  }

  function track(action) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'ch_delivery_popup', ch_popup_action: action });
  }

  function open() {
    var template = document.getElementById(TEMPLATE_ID);
    if (!template || !template.content) return;
    var dialog = template.content.firstElementChild.cloneNode(true);
    document.body.appendChild(dialog);

    var closed = false;
    function close(action) {
      if (closed) return;
      closed = true;
      writeStorage();
      track(action);
      document.documentElement.classList.remove('mdl-ch-popup-open');
      if (dialog.open) dialog.close();
      dialog.remove();
    }

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        close('backdrop');
        return;
      }
      var trigger = event.target.closest('[data-mdl-ch-close]');
      if (trigger) close(trigger.getAttribute('data-mdl-ch-close'));
      /* les CTA sont des liens : la navigation se poursuit normalement */
    });
    dialog.addEventListener('cancel', function () {
      close('escape');
    });

    document.documentElement.classList.add('mdl-ch-popup-open');
    dialog.showModal();
    var primary = dialog.querySelector('[data-mdl-ch-primary]');
    if (primary) primary.focus({ preventScroll: true });
    track('view');
  }

  /* --- Complément : géolocalisation IP (uniquement si l'heuristique locale ne conclut pas) --- */

  function readGeoCache() {
    try {
      var cached = JSON.parse(window.localStorage.getItem(GEO_CACHE_KEY) || 'null');
      if (cached && cached.country && Date.now() - cached.ts < GEO_CACHE_DAYS * 24 * 60 * 60 * 1000) {
        return cached.country;
      }
    } catch (e) {
      /* ignore */
    }
    return null;
  }

  function writeGeoCache(country) {
    try {
      window.localStorage.setItem(GEO_CACHE_KEY, JSON.stringify({ country: country, ts: Date.now() }));
    } catch (e) {
      /* ignore */
    }
  }

  function fetchGeo(url, parse) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, GEO_TIMEOUT_MS) : null;
    return fetch(url, { cache: 'no-store', credentials: 'omit', signal: controller ? controller.signal : undefined })
      .then(function (response) {
        if (!response.ok) throw new Error('geo ' + response.status);
        return response.text();
      })
      .then(function (body) {
        var country = parse(body);
        if (!/^[A-Z]{2}$/.test(country || '')) throw new Error('geo parse');
        return country;
      })
      .then(
        function (country) { clearTimeout(timer); return country; },
        function (error) { clearTimeout(timer); throw error; }
      );
  }

  function lookupCountry() {
    var cached = readGeoCache();
    if (cached) return Promise.resolve(cached);
    return fetchGeo('https://www.cloudflare.com/cdn-cgi/trace', function (body) {
      var match = /^loc=([A-Z]{2})$/m.exec(body);
      return match ? match[1] : '';
    })
      .catch(function () {
        return fetchGeo('https://api.country.is/', function (body) {
          return String((JSON.parse(body) || {}).country || '').toUpperCase();
        });
      })
      .then(function (country) {
        writeGeoCache(country);
        return country;
      });
  }

  function whenIdle(callback) {
    var run = function () {
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(callback, { timeout: 1000 });
      } else {
        setTimeout(callback, 1500);
      }
    };
    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run, { once: true });
  }

  function init() {
    if (isForced()) {
      open();
      return;
    }
    if (isDismissed()) return;
    if (isSwissVisitor()) {
      open();
      return;
    }
    /* Appel différé après le chargement de la page, résultat mis en cache : un seul appel par visiteur et par période. */
    whenIdle(function () {
      if (isDismissed()) return;
      lookupCountry().then(
        function (country) {
          if (country === 'CH' && !isDismissed()) open();
        },
        function () { /* échec réseau ou service indisponible : on n'affiche rien */ }
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
